import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import faker from "faker";
import strings from "translate/language";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export function Marketchart(props) {
  const {
    options = {
      responsive: true,
      plugins: {
        legend: {
          display: true,
          position: "top",
          labels: {
            fontColor: "black",
            fontSize: 14,
          },
        },
        title: {
          display: true,
          text: "",
        },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
            },
          ],
        },
      },
    },

    labels = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ],

    datasets,
  } = props;
  let data = {
    labels,
    datasets: datasets || [
      {
        label: strings.noOfProperty,
        data: labels.map(() => faker.datatype.number({ min: 0, max: 1000 })),
        backgroundColor: "#4466f2",
      },
      {
        label: strings.noOfUser,
        data: labels.map(() => faker.datatype.number({ min: 0, max: 1000 })),
        backgroundColor: "#22af47",
      },
      {
        label: strings.channelParters,
        data: labels.map(() => faker.datatype.number({ min: 0, max: 1000 })),
        backgroundColor: "#ff5370",
      },
    ],
  };
  return <Bar options={options} data={data} />;
}
